import { render } from "./PcLeftMenu.vue?vue&type=template&id=6ee4dae6&scoped=true"
import script from "./PcLeftMenu.vue?vue&type=script&lang=js"
export * from "./PcLeftMenu.vue?vue&type=script&lang=js"

import "./PcLeftMenu.vue?vue&type=style&index=0&id=6ee4dae6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee4dae6"]])

export default __exports__